import { ConfigurationEntryDto } from '@api/configuration';

export const CONFIG_LOADED = 'MetaConfig/loaded';

export function configLoaded(config: Record<string, ConfigurationEntryDto> | null): {
  type: typeof CONFIG_LOADED;
  payload: Record<string, ConfigurationEntryDto> | null;
} {
  return {
    type: CONFIG_LOADED,
    payload: config,
  };
}
